var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 18,
    viewBox: "0 0 120 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_471_1119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.01172L7.70734 8.96849L0 16.9003H3.96591L9.54479 11.1136L15.1403 16.9003H19.1228L3.83288 1.01172H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2234 3.14849C24.7268 4.57023 23.9785 6.44926 23.9785 8.76895C23.9785 11.0886 24.7351 13.0425 26.24 14.5723C27.7532 16.1021 29.6572 16.8754 31.9685 16.8754H40.9313V14.115H31.9685C30.447 14.115 29.1999 13.6411 28.2188 12.7016C27.2377 11.7538 26.7472 10.5233 26.7472 9.01006C26.7472 7.49686 27.2377 6.22478 28.2188 5.24369C29.1999 4.27092 30.4553 3.78038 31.9685 3.78038H40.9313V1.01172H31.9685C29.6322 1.01172 27.7116 1.72675 26.2234 3.14849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2124 7.51349H50.9004V10.2738H60.2124V16.8754H62.981V1.01172H60.2124V7.51349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6363 1.01172H46.876V16.8754H49.6363V1.01172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0664 1.46811C79.6341 1.12722 79.2184 0.960938 78.811 0.960938C78.4368 0.960938 78.0211 1.13554 77.5555 1.49305C77.1647 1.80068 76.8654 2.14156 76.6493 2.51571L68.0273 16.8745H71.5775L78.7361 5.09313L81.4882 9.64936H77.2978L75.6266 12.4097H83.1593L85.8116 16.8495L89.3784 16.8745L80.9727 2.51571C80.7399 2.11662 80.4406 1.76742 80.0664 1.46811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1685 1.01172H94.4082V16.8754H97.1685V1.01172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.231 1.01027V12.0184L107.055 1.81675C106.514 1.27632 105.982 1.00195 105.475 1.00195C105.101 1.00195 104.818 1.13498 104.619 1.40935C104.419 1.68372 104.319 1.99967 104.319 2.37381V16.8656H107.063V5.86581L117.231 16.0924C117.872 16.7243 118.445 17.0402 118.952 17.0402C119.651 17.0402 120 16.533 120 15.5104V1.01027H117.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.543 6.0668L12.4719 8.07054L19.3062 1.01172H15.4733L10.543 6.0668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_471_1119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 16.0798,
    fill: "white",
    transform: "translate(0 0.960938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5598b4fb24e691996c9e05515a8d7fea.svg";
export { ForwardRef as ReactComponent };